var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"xs-12 p4"},_vm._l((_vm.passwordRules),function(item,i){return _c('li',{key:i,staticClass:"fs3 c1 lh150 c1"},[_vm._v("\n\t\t"+_vm._s(item)+"\n\t")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }